module.exports = __webpack_public_path__ + "static/img/106_TO8_1793_og.2bacbf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/106_TO8_1793_og.jpg
// module id = +hXo
// module chunks = 0